const normaliserTexte = (valeur) => String(valeur ?? '').trim();

export function exerciceFiscalDuMois(annee, mois) {
  const anneeNombre = Number(annee);
  const moisNombre = Number(mois);
  if (!Number.isInteger(anneeNombre) || !Number.isInteger(moisNombre) || moisNombre < 1 || moisNombre > 12) {
    throw new Error('CONTEXTE_FILTRES_INVALIDE');
  }
  return moisNombre >= 4 ? anneeNombre : anneeNombre - 1;
}

export function creerDashboardFilterContext({
  groupe, utilisateur, commercial = 'Moi', modePeriode = 'Toutes périodes', annee, mois,
  exercice, semaine = '1', dateDepuis = '', sport = 'Tous les sports',
  statutFinancier = 'Tous', recherche = ''
}) {
  const anneeNombre = Number(annee);
  const moisNombre = Number(mois);
  const commercialSelectionne = normaliserTexte(commercial) || 'Moi';
  const utilisateurNom = normaliserTexte(utilisateur?.nom);
  const commercialAnalyse = commercialSelectionne === 'Moi' ? (utilisateurNom || 'Moi') : commercialSelectionne;
  const exerciceDerive = exerciceFiscalDuMois(anneeNombre, moisNombre);
  const exerciceActif = ['Exercice fiscal'].includes(String(modePeriode))
    ? Number(exercice || exerciceDerive)
    : exerciceDerive;
  return Object.freeze({
    groupe: normaliserTexte(groupe), utilisateur: utilisateur || null,
    commercialSelectionne, commercialAnalyse,
    modePeriode: normaliserTexte(modePeriode) || 'Toutes périodes',
    annee: anneeNombre, mois: moisNombre, exercice: exerciceActif,
    semaine: normaliserTexte(semaine) || '1', dateDepuis: normaliserTexte(dateDepuis),
    sport: normaliserTexte(sport) || 'Tous les sports',
    statutFinancier: normaliserTexte(statutFinancier) || 'Tous', recherche: String(recherche || '')
  });
}
